import { Formik } from 'formik';
import React from 'react';
import { Form } from 'reactstrap';
import Backend from '../../../Layouts/Backend';
import { validationSchema } from './validation';
import Moment from 'moment';
import { withTranslation } from 'react-i18next';
import MonitoringPoints from '../../../UI/MonitoringPoints';
import TimeSelector from '../../../UI/TimeSelector';
import { connect } from 'react-redux';
import Loading from '../../../Helpers/Loading';
import lookupActions from '../../../../actions/lookup.actions';
import { reportActions } from '../../../../actions/report.actions';
import helper from '../../../../utils/helper';
import { Alert, Button, Dropdown } from '../../../UI/Common';
import { bindActionCreators } from 'redux';
import moment from 'moment';
import ReactSelect from '../../../UI/ReactSelect';

function DefaultUI(props) {
  const { t } = props;
  const [groups, setGroups] = React.useState([]);
  const [errors, setErrors] = React.useState('');
  const [loading, setLoading] = React.useState(false);
  const [isFetchingReport, setFetchingReport] = React.useState(false);
  React.useEffect(() => {
    async function getGroups() {
      await props.reportActions.clearReport();
      await props.lookupActions.getGroups();
    }
    setLoading(true);
    getGroups();
    setLoading(false);
  }, []);
  React.useEffect(() => {
    setGroups(props.lookup.groups);
  }, [props.lookup.groups]);
  React.useEffect(() => {
    setErrors(
      helper.centralizeError([props.lookup.errors, props.report.error]),
    );
  }, [props.lookup.errors, props.report.error]);
  React.useEffect(() => {
    setFetchingReport(props.report.isFetching);
  }, [props.report.isFetching]);
  const form = {
    groupId: undefined,
    sensorIds: [],
    fromDate: Moment().subtract(1, 'month').toDate(),
    toDate: new Date(),
    format: 'pdf',
  };
  if (loading) {
    return (
      <Backend>
        <Loading />
      </Backend>
    );
  }
  return (
    <Backend>
      <div className="content-inner">
        <Alert.Error text={errors} />
        <Formik
          initialValues={form}
          validationSchema={validationSchema}
          onSubmit={(values) => props.onGetReport(values)}
        >
          {({
            values,
            errors,
            setFieldTouched,
            setFieldValue,
            touched,
            handleSubmit,
          }) => {
            return (
              <Form>
                <ReactSelect
                  required
                  containerStyle={{ width: '30%' }}
                  name="groupId"
                  label="Group"
                  options={groups}
                  value={values.groupId}
                  onChange={({ value }) => {
                    setFieldValue('groupId', value);
                  }}
                  valueKey="id"
                  labelKey="name"
                  invalid={touched.groupId}
                  error={errors.groupId}
                />
                <MonitoringPoints
                  groupId={values.groupId}
                  onSelect={(sensorIds) => {
                    setFieldTouched('sensorIds', false);
                    setFieldValue('sensorIds', sensorIds);
                  }}
                  invalid={touched.sensorIds}
                  error={errors.sensorIds}
                />
                <TimeSelector
                  onChange={(fromDate, toDate) => {
                    setFieldValue('fromDate', fromDate);
                    setFieldValue('toDate', toDate);
                  }}
                />
                <div>
                  <Button
                    id="pdf-export"
                    classes="mr-20"
                    loading={isFetchingReport}
                    onClick={(e) => {
                      e.preventDefault();
                      setFieldValue('format', 'pdf');
                      handleSubmit();
                    }}
                  >
                    {t('PDF')}
                  </Button>
                  <Button
                    id="excel-export"
                    classes="mr-20"
                    loading={isFetchingReport}
                    onClick={(e) => {
                      e.preventDefault();
                      setFieldValue('format', 'excel');
                      handleSubmit();
                    }}
                  >
                    {t('Excel')}
                  </Button>
                  <Button
                    id="word-export"
                    loading={isFetchingReport}
                    classes="mr-20"
                    onClick={(e) => {
                      e.preventDefault();
                      setFieldValue('format', 'word');
                      handleSubmit();
                    }}
                  >
                    {t('Word')}
                  </Button>
                  {props.csvIncluded ? (
                    <Button
                      id="word-export"
                      loading={isFetchingReport}
                      onClick={(e) => {
                        e.preventDefault();
                        setFieldValue('format', 'csv');
                        handleSubmit();
                      }}
                    >
                      CSV
                    </Button>
                  ) : null}
                </div>
              </Form>
            );
          }}
        </Formik>
      </div>
    </Backend>
  );
}

function mapStateToProps(state) {
  return {
    report: state.report,
    lookup: state.lookup,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    lookupActions: bindActionCreators(
      Object.assign({}, lookupActions),
      dispatch,
    ),
    reportActions: bindActionCreators(
      Object.assign({}, reportActions),
      dispatch,
    ),
  };
}

export default withTranslation('app')(
  connect(mapStateToProps, mapDispatchToProps)(DefaultUI),
);
